import React from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { ActivitiesFacilities, OurRecruiters, PlacementProcess, PlacementStatistics, PlacementTeam } from './TabsContent';
import './slidingTab.scss';

export default function SlidingTab() {
    return (
      <div className='sliding-tabs'>
        <Tabs defaultActiveKey="Placement Process" id="sliding-tabs" className="mb-3" variant="tabs">
        <Tab eventKey="Placement Process" title="Placement Process">
         <PlacementProcess />
        </Tab>
        <Tab className='statistics' eventKey="Placement Statistics" title="Placement Statistics">
         <PlacementStatistics />
        </Tab>
        <Tab eventKey="Our recruiters" title="Our recruiters">
         <OurRecruiters />
        </Tab>
        <Tab eventKey="Activities & Facilities" title="Activities & Facilities">
        <ActivitiesFacilities />
        </Tab>
        <Tab eventKey="Placement Team" title="Placement Team">
         <PlacementTeam />
        </Tab>
      </Tabs>
      </div>
        
    )
}
